import React from 'react'
import { Icon as RIKIcon } from 'react-icons-kit'
import cx from 'classnames'

import styles from './Icon.module.scss'

export * from './model'

export const Icon = React.forwardRef(
  (
    {
      ariaLabel,
      className = undefined,
      onClick,
      icon,
      size = 16,
      style,
      title,
    },
    ref,
  ) => (
    <RIKIcon
      aria-label={ariaLabel}
      className={cx(styles.icon, { [className]: Boolean(className) })}
      role="img"
      itemRef={ref}
      {...{ icon, size, title, style, onClick }}
    />
  ),
)

